import intl from "react-intl-universal"

function LanguageMap (value = null) {
  let data = [
    {
      label: intl.get('sys.en'),
      value: 'en'
    },
    {
      label: intl.get('sys.zh_cn'),
      value: 'zh-CN'
    },
    {
      label: intl.get('sys.zh_tw'),
      value: 'zh-TW'
    },
    {
      label: intl.get('sys.vi'),
      value: 'vi'
    },
    {
      label: intl.get('sys.tr'),
      value: 'tr'
    },
    {
      label: intl.get('sys.tl'),
      value: 'tl'
    },
    {
      label: intl.get('sys.th'),
      value: 'th'
    },
    {
      label: intl.get('sys.sv'),
      value: 'sv'
    },
    {
      label: intl.get('sys.ru'),
      value: 'ru'
    },
    {
      label: intl.get('sys.pt'),
      value: 'pt'
    },
    {
      label: intl.get('sys.pl'),
      value: 'pl'
    },
    {
      label: intl.get('sys.no'),
      value: 'no'
    },
    {
      label: intl.get('sys.nl'),
      value: 'nl'
    },
    {
      label: intl.get('sys.ko'),
      value: 'ko'
    },
    {
      label: intl.get('sys.ja'),
      value: 'ja'
    },
    {
      label: intl.get('sys.it'),
      value: 'it'
    },
    {
      label: intl.get('sys.id'),
      value: 'id'
    },
    {
      label: intl.get('sys.fr'),
      value: 'fr'
    },
    {
      label: intl.get('sys.es'),
      value: 'es'
    },
    {
      label: intl.get('sys.el'),
      value: 'el'
    },
    {
      label: intl.get('sys.de'),
      value: 'de'
    },
    {
      label: intl.get('sys.ar'),
      value: 'ar'
    },
    {
      label: intl.get('sys.ms'),
      value: 'ms'
    }
  ]
  if (value) {
    let label = value
    data.forEach(item => {
      if (item.value === value) {
        label = item.label
      }
    })
    return label
  }
  return data
}
export { LanguageMap }